import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../base-component/player-listener.component'
import { convertITrackToPlayerTrack, ITrack } from '../../../Interface/track'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService } from '../../../services/cart.service'
import { SsrService } from '../../../services/ssr.service'
import { TracksService } from '../../../services/tracks.service'

@Component({
  selector: 'bmcore-fav-tracks-page',
  templateUrl: './bmcore-fav-tracks-page.component.html',
  styleUrls: ['./bmcore-fav-tracks-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreFavTracksPageComponent extends PlayerListenerComponentDirective<ITrack> implements OnInit {
  pageSize = 100
  tracks: ITrack[] = []
  showNotFavTracksMessage = false
  isLoader = false

  constructor(
    private tracksService: TracksService,
    public player: PlayerLogic,
    protected cartService: CartService,
    private ssrService: SsrService
  ) {
    super(player, cartService)
  }

  ngOnInit(): void {
    this.isLoader = true
    this.ssrService.wait('bmcore-fav-tracks-page')
    this.tracksService.getFavoriteBeats(this.pageSize).subscribe(resp => {
      this.ssrService.ready('bmcore-fav-tracks-page')
      this.isLoader = false
      this.tracks = resp.items
      this.showNotFavTracksMessage = !resp.items.length
    })
  }

  setPlaylist() {
    this.player.setPlayList(this.tracks.map(convertITrackToPlayerTrack))
  }
}
